import { createContext } from 'react';

import type { AuditTrailProviderContextType } from './types';

export const AuditTrailContext = createContext<AuditTrailProviderContextType>({
  getAuditTrailFile: async () => {},
  loading: false,
  disabled: false,
  hasAuditTrail: false,
});
